/* RbgColor -- handles hex string parsing, manipulation and creation */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define([], factory);
  } else if (typeof module === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory();
  } else {
    // Browser globals (root is window)
    root.returnExports = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {

  var module = {};

  module.buildRgbColorFromHexString = function (rgbHexString) {
    if (rgbHexString.length !== 6) {
      throw "RGB hex string must have length 6";
    }

    var rgb = [];
    for (var i = 0; i < 3; ++i) {
      var start = 2 * i;
      rgb[i] = parseInt(rgbHexString.substr(start, 2), 16);
    }

    return new RgbColor(rgb);
  };

  function RgbColor(rgbIntArray) {
    if (rgbIntArray.length !== 3) {
      throw "RGB array must have length 3";
    }
    this.rgbIntArray = rgbIntArray;
  }

  RgbColor.prototype.luma = function () {
    var lumaCoefficients = [0.2126, 0.7152, 0.0722];
    var luma = 0;

    for (var i = 0; i < lumaCoefficients.length; ++i) {
      luma += lumaCoefficients[i] * this.rgbIntArray[i];
    }

    return luma;
  };

  RgbColor.prototype.getContrasting = function () {
    if (this.luma() > 128) {
      return new RgbColor([0, 0, 0]);
    } else {
      return new RgbColor([255, 255, 255]);
    }
  };

  RgbColor.prototype.hexString = function () {
    var hexString = "";

    for (var i = 0; i < 3; ++i) {
      var hexComponent = this.rgbIntArray[i].toString(16);
      hexString += hexComponent.length > 1 ? "" : "0";
      hexString += hexComponent;
    }

    return hexString;
  };

  return module;
}));